// Builders CSV pour les 5 datasets de la page /stats — fonctions pures testables.
// Les labels FR (étape, type d'affaire) sont résolus ici pour que le CSV soit
// directement lisible dans Excel sans avoir besoin de la table de mapping.

import { buildCsv } from './csvExport';
import {
  DOSSIER_STAGE_LABELS,
  DOSSIER_TYPE_LABELS,
  type DossierStage,
  type DossierType,
} from '../dossiers/dossierService';
import type {
  StatsDossiersByStage,
  StatsDossiersByType,
  StatsRevenueMonthly,
  StatsHoursByLawyer,
  StatsDossierProfitability,
} from './statsService';

function stageLabel(s: string | null | undefined): string {
  if (!s) return '';
  return DOSSIER_STAGE_LABELS[s as DossierStage] ?? s;
}

function typeLabel(t: string | null | undefined): string {
  if (!t) return '';
  return DOSSIER_TYPE_LABELS[t as DossierType] ?? t;
}

/** Format un montant en euros sans symbole (Excel formate ensuite). */
function num(n: unknown): number {
  if (n === null || n === undefined || n === '') return 0;
  return Number(n);
}

export function buildDossiersByStageCsv(rows: StatsDossiersByStage[]): string {
  return buildCsv(
    ['Étape', 'Code étape', 'Nombre de dossiers'],
    rows.map((r) => [stageLabel(r.stage), r.stage ?? '', num(r.count)]),
  );
}

export function buildDossiersByTypeCsv(rows: StatsDossiersByType[]): string {
  return buildCsv(
    ["Type d'affaire", 'Code type', 'Nombre de dossiers'],
    rows.map((r) => [typeLabel(r.type_affaire), r.type_affaire ?? '', num(r.count)]),
  );
}

export function buildRevenueMonthlyCsv(rows: StatsRevenueMonthly[]): string {
  return buildCsv(
    ['Mois', 'CA HT (€)'],
    rows.map((r) => [r.month_start ?? '', num(r.ca_ht)]),
  );
}

export function buildHoursByLawyerCsv(rows: StatsHoursByLawyer[]): string {
  return buildCsv(
    ['Avocat', 'Heures totales', 'Heures facturées'],
    rows.map((r) => [r.full_name ?? '', num(r.hours_total), num(r.hours_billed)]),
  );
}

export function buildProfitabilityCsv(rows: StatsDossierProfitability[]): string {
  return buildCsv(
    [
      'Numéro',
      'Intitulé',
      'Étape',
      'Heures facturables',
      'Valeur des heures (€)',
      'Facturé HT (€)',
      'Marge (€)',
    ],
    rows.map((r) => [
      r.number ?? '',
      r.title ?? '',
      stageLabel(r.stage),
      num(r.hours_billable),
      num(r.hours_amount),
      num(r.invoiced_ht),
      num(r.margin),
    ]),
  );
}
